import { Project } from "interfaces";
import { labelOwner } from "_constants";
import { VisibilityChip } from "components/shared";

export const FooterCardProject = ({ project }: { project: Project }) => {
  return (
    <div className="footer-card">
      <div className="update">
        <span className="text-base-regular">{labelOwner + " "}</span>
        <span className="text font-weight-600 capitalize clamp-1">
          {project.createdBy ?? ""}
        </span>
      </div>
      <VisibilityChip type={project.type} />
    </div>
  );
};
